// extracted by mini-css-extract-plugin
export default {"consent":"CookieModal_consent__3b1gP","consentGrid":"CookieModal_consentGrid__NnzD-","buttonGrid":"CookieModal_buttonGrid__fb+9K","consentModal":"CookieModal_consentModal__adL56"};